const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const AT = require("../../core/vault/ActionTypes");
const OpsParentSubChange = require("../vault/OpsParentSubChange");
const Information = require("../../office/checkout/Information");
const RadioItem = require("../../office/RadioItem");
const Checkbox = require("../../core/view/Checkbox");
const withAnimateScroll = require("../../core/hoc/withAnimateScroll");
const UnderlineView = require("../../office/UnderlineView");
const SubscriptionSummaryAccount = require("./SubscriptionSummaryAccount");
const ShippingMethod = require("../../office/checkout/ShippingMethod");
const ShippingCombineOrders = require("../../office/checkout/ShippingCombineOrders");
const BookstoreUtil = require("../../../shared/BookstoreUtil");

const styles = require("./styles/SubscriptionShipping.css");

const augment = function(Component) {
	Component = withAnimateScroll(Component);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "SubscriptionShipping",

		propTypes: {
			account: PT.object.isRequired,
			onContinue: PT.func,
			dispatch: PT.func.isRequired,

			// Injected by HOCs
			animateScroll: PT.func.isRequired,
		},

		getValidation: function() {
			return OpsParentSubChange.checkShipping(this.props.account);
		},

		updateField: function(field, val) {
			this.props.dispatch({
				type: AT.SUBSCRIPTION_CHANGE_EDIT_SHIPPING,
				values: {[field]: val},
			});
		},

		onSetNewDefault: function(value) {
			this.props.dispatch({
				type: AT.SUBSCRIPTION_CHANGE_SET_SHIPPING_NEW_DEFAULT,
				value,
			});
		},

		onSetCopyAccount: function(value) {
			this.props.dispatch({
				type: AT.SUBSCRIPTION_CHANGE_SET_USING_ACCOUNT_ADDRESS,
				value,
			});
		},

		onContinue: function() {
			const validation = this.getValidation();
			if (validation.isComplete) {
				const act = OpsParentSubChange.getFinishShippingAction(
					this.props.account
				);
				if (act) {
					this.props.dispatch(act);
				} else {
					this.props.onContinue();
				}
			} else {
				this.props.dispatch({type: AT.SUBSCRIPTION_CHANGE_SHOW_ALL_VALIDATION});
			}
		},

		render: function() {
			const {account} = this.props;
			const shippingInfo = OpsParentSubChange.getShipping(account);
			const {
				usingAccountAddress,
				shippingIsNewDefault,
			} = account.subChangeState;
			const getPriceForMethod = method => {
				return OpsParentSubChange.calculateShippingPriceWithMethod(
					account,
					method
				);
			};

			let shippingEl = null;
			let shippingIsNewDefaultEl = null;

			const validation = this.getValidation();
			const showError = !_.isEmpty(validation.errorTypes);

			const isBundlePurchase = OpsParentSubChange.isNewBundlePlanType(
				this.props.account
			);

			let addressOnFileLabel = "Use address on file";
			if (!account.hasShipping) {
				addressOnFileLabel = "Same as billing";
			}

			if (!usingAccountAddress) {
				const invalidAddressGroup = validation.invalidAddressGroup || false;
				shippingEl = (
					<Information
						values={shippingInfo}
						initialTabIndex={10}
						updateField={this.updateField}
						errorFields={validation}
						className={styles.information}
						invalidAddressGroup={invalidAddressGroup}
						addressType={"shipping"}
					/>
				);
			} else {
				const lines = BookstoreUtil.formatAddressFromData(shippingInfo);
				const inner = lines.map((line, i) => (
					<span key={"line" + i}>
						{line}
						<br />
					</span>
				));
				shippingEl = <div className={styles.address}>{inner}</div>;
			}

			if (
				!usingAccountAddress &&
				!OpsParentSubChange.mustSaveShippingAsDefault(account)
			) {
				shippingIsNewDefaultEl = (
					<Checkbox
						className={styles.newDefault}
						text="Save as default shipping address"
						onClick={this.onSetNewDefault}
						isSelected={shippingIsNewDefault}
						noTextHover={true}
						tabIndex={100}
					/>
				);
			}

			const createButton = (text, tabIndex, shouldCopy) => {
				const isSelected = usingAccountAddress === shouldCopy;
				return (
					<RadioItem
						className={styles.radioItem}
						text={text}
						onClick={() => this.onSetCopyAccount(shouldCopy)}
						isSelected={isSelected}
						tabIndex={tabIndex}
					/>
				);
			};

			let summaryButtonText, summaryOnContinue;
			const blockedShipping = OpsParentSubChange.needsShippingToBlockedAddress(
				account
			);
			if (blockedShipping) {
				summaryOnContinue = () => this.props.animateScroll();
				summaryButtonText = "See Above";
			} else {
				summaryOnContinue = this.onContinue;
				summaryButtonText = "Review";
			}

			return (
				<div className={styles.main}>
					<div className={styles.title}>
						<UnderlineView text="Shipping Information" />
					</div>
					<div className={styles.across}>
						<div className={styles.formContainer}>
							<div>
								<ShippingMethod
									shippingInfo={shippingInfo}
									getPriceForMethod={getPriceForMethod}
									updateField={this.updateField}
									validation={validation}
									initialTabIndex={1}
								/>
								<div className={styles.subtitle}>Shipping Address:</div>
								<div className={styles.buttons}>
									{createButton(addressOnFileLabel, 8, true)}
									{createButton("Use different address", 9, false)}
								</div>
								{shippingEl}
								{shippingIsNewDefaultEl}
								{isBundlePurchase && (
									<ShippingCombineOrders
										comments={shippingInfo && shippingInfo.comments}
										onCommentsChange={comments =>
											this.updateField("comments", comments)
										}
										tabIndex={21}
									/>
								)}
							</div>
						</div>
						<SubscriptionSummaryAccount
							account={account}
							showItemize={true}
							onContinue={summaryOnContinue}
							showError={showError}
							buttonText={summaryButtonText}
							tabIndex={500}
						/>
					</div>
				</div>
			);
		},
	})
);
